query GetSmsEmailUnsubscribes($contactId: ID!) {
    contact(id: $contactId) {
        id
        hasUnsubscribedFromEmailAndSmsMarketing
        preferenceCenterLink
    }
}
